var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMessageTextLined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 21C14.25 18.9289 15.9289 17.25 18 17.25H78C80.0711 17.25 81.75 18.9289 81.75 21V65C81.75 67.0711 80.0711 68.75 78 68.75H30.8838C28.3775 68.75 26.0072 69.8892 24.4416 71.8463L14.25 84.5857V21ZM18 12.75C13.4436 12.75 9.75 16.4437 9.75 21V85.8686C9.75 89.697 14.5709 91.3881 16.9625 88.3986L27.9555 74.6574C28.6671 73.7678 29.7446 73.25 30.8838 73.25H78C82.5564 73.25 86.25 69.5564 86.25 65V21C86.25 16.4436 82.5563 12.75 78 12.75H18ZM25.7505 35.0001C25.7505 33.7574 26.7578 32.7501 28.0005 32.7501L52.0005 32.7501C53.2431 32.7501 54.2505 33.7574 54.2505 35.0001C54.2505 36.2427 53.2431 37.2501 52.0005 37.2501L28.0005 37.2501C26.7578 37.2501 25.7505 36.2427 25.7505 35.0001ZM25.7505 51C25.7505 49.7574 26.7578 48.75 28.0005 48.75L68.0005 48.75C69.2431 48.75 70.2505 49.7574 70.2505 51C70.2505 52.2426 69.2431 53.25 68.0005 53.25L28.0005 53.25C26.7578 53.25 25.7505 52.2426 25.7505 51Z",
    fill: "url(#paint0_linear_601_7279)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_601_7279",
    x1: 86.25,
    y1: 89.9266,
    x2: 9.75,
    y2: 89.9266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84FFE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ACAAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMessageTextLined);
export default __webpack_public_path__ + "static/media/ic_message_text_lined.f9416357944ade83f1d691e6775fa2dd.svg";
export { ForwardRef as ReactComponent };